import instance from './instance';

export default {
  instance,
};
